/* Nivala Diwali 2026 — page behaviour for the Diwali Pantry and Nivala for Families pages.
   Uses Shopify's AJAX cart API (/cart.js, /cart/add.js, /cart/change.js) — the same cart as checkout.
   Add buttons use [data-nvd-add] (not [data-add-to-cart]/[data-nvs-add]) on purpose, so the site-wide
   kids-kit cross-sell popup (sections/nivala-upsell.liquid) does not fire on these festive pages. */
(function () {
  if (window.NVD) return;
  var NVD = (window.NVD = {});
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function money(paise) { return '₹' + Math.round(paise / 100).toLocaleString('en-IN'); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function sizedImg(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  document.body.classList.add('nvd-page');
  if (!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) document.documentElement.style.scrollBehavior = 'smooth';

  /* ---------------- toast ---------------- */
  var toast, toastMsg, toastTimer;
  function showToast(msg, isError) {
    toast = toast || $('[data-nvd-toast]');
    if (!toast) return;
    toastMsg = toastMsg || $('[data-nvd-toast-msg]', toast);
    toastMsg.textContent = msg;
    toast.classList.toggle('nvd-toast--error', !!isError);
    toast.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-show'); }, isError ? 4200 : 3000);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-nvd-toast-view]')) { if (toast) toast.classList.remove('is-show'); openDrawer(); }
  });

  /* ---------------- cart state ---------------- */
  var cart = null;
  function fetchCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; renderCart(); return c; });
  }
  NVD.refresh = fetchCart;

  function updateCounts() {
    var n = cart ? cart.item_count : 0;
    $$('[data-nvd-count]').forEach(function (el) { el.textContent = n; });
    $$('[data-nvd-count-wrap]').forEach(function (el) { el.hidden = n === 0; });
    /* bubble on the site header's cart button */
    var trigger = $('[data-cart-trigger]');
    if (trigger) {
      if (getComputedStyle(trigger).position === 'static') trigger.style.position = 'relative';
      var b = $('.nvd-cart-count', trigger);
      if (!b) { b = document.createElement('span'); b.className = 'nvd-cart-count'; b.setAttribute('aria-hidden', 'true'); trigger.appendChild(b); }
      b.textContent = n;
      if (n === 0) b.setAttribute('data-zero', ''); else b.removeAttribute('data-zero');
      trigger.setAttribute('aria-label', 'Open cart (' + n + (n === 1 ? ' item)' : ' items)'));
    }
  }

  /* ---------------- drawer ---------------- */
  var drawer = $('[data-nvd-drawer]');
  var lastFocus = null;
  function openDrawer() {
    if (!drawer) { window.location.href = root + 'cart'; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { var c = $('[data-nvd-close].nvd-drawer__close', drawer); if (c) c.focus(); }, 280);
    fetchCart();
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (drawer) {
    /* The site header's cart button calls document.querySelector('cart-drawer').open() */
    drawer.open = openDrawer;
    drawer.close = closeDrawer;
    /* Dawn's product-form.js / quick-add.js may look for a cart-drawer and call these; keep them harmless. */
    drawer.getSectionsToRender = function () { return []; };
    drawer.renderContents = function () { openDrawer(); };
    drawer.setActiveElement = function () {};
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-nvd-close]')) { closeDrawer(); return; }
      var line = e.target.closest('[data-key]');
      if (!line || !cart) return;
      var key = line.getAttribute('data-key');
      var item = cart.items.filter(function (i) { return i.key === key; })[0];
      if (!item) return;
      if (e.target.closest('[data-qplus]')) changeLine(key, item.quantity + 1);
      else if (e.target.closest('[data-qminus]')) changeLine(key, item.quantity - 1);
      else if (e.target.closest('[data-remove]')) changeLine(key, 0);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  function renderCart() {
    updateCounts();
    if (!drawer || !cart) return;
    var body = $('[data-nvd-lines]', drawer), foot = $('[data-nvd-foot]', drawer);
    renderXsell();
    if (!cart.item_count) {
      body.innerHTML = '<p class="nvd-drawer__empty">Your cart is empty.</p>';
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map(function (it) {
      var props = '';
      if (it.properties) {
        Object.keys(it.properties).forEach(function (k) {
          if (k.charAt(0) === '_' || !it.properties[k]) return;
          props += '<div class="nvd-line__meta">' + esc(k) + ': ' + esc(it.properties[k]) + '</div>';
        });
      }
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="nvd-line__meta">' + esc(it.variant_title) + '</div>' : '';
      var img = it.image ? '<img src="' + esc(sizedImg(it.image, 160)) + '" alt="" width="64" height="80" loading="lazy">' : '<span class="nvd-line__noimg"></span>';
      return '<div class="nvd-line" data-key="' + esc(it.key) + '">' + img +
        '<div><div class="nvd-line__top"><span>' + esc(it.product_title) + '</span><span>' + money(it.final_line_price) + '</span></div>' +
        variant + props +
        '<div class="nvd-line__ctrl"><div class="nvd-qty"><button type="button" data-qminus aria-label="Decrease quantity of ' + esc(it.product_title) + '">−</button>' +
        '<span aria-live="polite">' + it.quantity + '</span><button type="button" data-qplus aria-label="Increase quantity of ' + esc(it.product_title) + '">+</button></div>' +
        '<button type="button" class="nvd-line__remove" data-remove>Remove</button></div></div></div>';
    }).join('');
    $('[data-nvd-subtotal]', drawer).textContent = money(cart.items_subtotal_price);
  }

  /* Cross-sell inside the drawer: only products from this page's own Diwali range, never ones already in the cart. */
  function renderXsell() {
    var box = drawer && $('[data-nvd-xsell]', drawer);
    if (!box || !cart) return;
    var inCart = cart.items.map(function (i) { return i.product_id; });
    var limit = parseInt(box.getAttribute('data-limit') || '3', 10), shown = 0;
    $$('[data-nvd-xs]', box).forEach(function (li) {
      var show = inCart.indexOf(parseInt(li.getAttribute('data-product'), 10)) < 0 && shown < limit;
      li.hidden = !show;
      if (show) shown++;
    });
    box.hidden = shown === 0;
  }

  var busy = false;
  function changeLine(key, qty) {
    if (busy) return;
    busy = true;
    fetch(root + 'cart/change.js', { method: 'POST', headers: JSON_HEADERS, credentials: 'same-origin', body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (c) { if (c && c.items) { cart = c; renderCart(); } else return fetchCart(); })
      .catch(function (err) { showToast((err && (err.description || err.message)) || 'Couldn’t update your cart', true); fetchCart(); })
      .then(function () { busy = false; });
  }

  function addItems(items, label, btn) {
    if (btn) { btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); }
    return fetch(root + 'cart/add.js', { method: 'POST', headers: JSON_HEADERS, credentials: 'same-origin', body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetchCart().catch(function () {}); })
      .then(function () {
        if (drawer && drawer.hasAttribute('data-open-on-add')) {
          var live = $('[data-nvd-drawer-live]', drawer); if (live) live.textContent = label + ' added to cart';
          if (!drawer.classList.contains('is-open')) openDrawer();
        } else showToast(label + ' added to cart');
        return true;
      })
      .catch(function (err) { showToast((err && (err.description || err.message)) || 'Couldn’t add that — please try again', true); return false; })
      .then(function (ok) { if (btn) { btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); } return ok; });
  }
  NVD.addItems = addItems;

  /* ---------------- product cards ---------------- */
  function cardData(card) {
    if (card._nvd) return card._nvd;
    var s = $('script[data-nvd-variants]', card);
    card._nvd = s ? JSON.parse(s.textContent) : [];
    return card._nvd;
  }
  function syncCard(card) {
    var variants = cardData(card);
    var checked = $('input[type="radio"][data-nvd-variant]:checked', card);
    var id = checked ? parseInt(checked.value, 10) : (variants[0] && variants[0].id);
    var v = variants.filter(function (x) { return x.id === id; })[0] || variants[0];
    if (!v) return;
    var btn = $('[data-nvd-add]', card), price = $('[data-nvd-price]', card);
    if (price) price.innerHTML = money(v.price) + (v.compare > v.price ? '<s>' + money(v.compare) + '</s>' : '');
    if (btn) {
      btn.setAttribute('data-nvd-add', v.id);
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-soldout');
    }
  }
  $$('[data-nvd-card]').forEach(syncCard);
  document.addEventListener('change', function (e) {
    if (e.target.matches('input[data-nvd-variant]')) syncCard(e.target.closest('[data-nvd-card]'));
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nvd-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var id = parseInt(btn.getAttribute('data-nvd-add'), 10);
    if (!id) return;
    addItems([{ id: id, quantity: 1 }], btn.getAttribute('data-nvd-title') || 'Item', btn);
  });

  /* gallery arrows + dots */
  function showSlide(media, i) {
    var imgs = $$('.nvd-card__img', media), dots = $$('.nvd-card__dot', media);
    if (!imgs.length) return;
    i = (i + imgs.length) % imgs.length;
    imgs.forEach(function (im, k) {
      var on = k === i;
      im.classList.toggle('is-active', on);
      im.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on && im.loading === 'lazy') im.loading = 'eager';
    });
    dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    media.setAttribute('data-index', i);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-nvd-slide]');
    if (!a) return;
    var media = a.closest('[data-nvd-gallery]');
    var cur = parseInt(media.getAttribute('data-index') || '0', 10);
    var dir = a.getAttribute('data-nvd-slide');
    showSlide(media, dir === 'prev' ? cur - 1 : dir === 'next' ? cur + 1 : parseInt(dir, 10));
  });
  /* swipe on touch */
  $$('[data-nvd-gallery]').forEach(function (media) {
    var x0 = null;
    media.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    media.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) < 40) return;
      var cur = parseInt(media.getAttribute('data-index') || '0', 10);
      showSlide(media, dx < 0 ? cur + 1 : cur - 1);
    }, { passive: true });
  });

  /* ---------------- hamper "What's inside" toggles (mobile) ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nvd-toggle]');
    if (!t) return;
    var list = document.getElementById(t.getAttribute('aria-controls'));
    var open = t.getAttribute('aria-expanded') !== 'true';
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    var g = $('span', t); if (g) g.textContent = open ? '−' : '+';
    if (list) list.hidden = !open;
  });

  /* ---------------- category pills: active state ---------------- */
  var pills = $$('[data-nvd-pill]');
  if (pills.length && 'IntersectionObserver' in window) {
    var targets = pills.map(function (p) { return document.getElementById((p.getAttribute('href') || '').replace('#', '')); }).filter(Boolean);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        pills.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('href') === '#' + en.target.id); });
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    targets.forEach(function (t) { io.observe(t); });
  }

  /* ---------------- mobile sticky CTA ---------------- */
  var sticky = $('[data-nvd-sticky]');
  if (sticky) {
    var threshold = parseInt(sticky.getAttribute('data-threshold') || '600', 10);
    var stop = $('[data-nvd-sticky-stop]');
    var stopVisible = false;
    if (stop && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { stopVisible = en[0].isIntersecting; onScroll(); }).observe(stop);
    }
    var onScroll = function () {
      var show = window.scrollY > threshold && !stopVisible;
      sticky.classList.toggle('is-show', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      sticky.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('nvd-sticky-on', show && window.matchMedia('(max-width: 749px)').matches);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- build your own box ---------------- */
  $$('[data-nvd-builder]').forEach(function (bx) {
    var max = parseInt(bx.getAttribute('data-max') || '6', 10);
    var prop = bx.getAttribute('data-property') || 'Diwali box';
    var picked = [];
    var chips = $$('[data-nvd-chip]', bx);
    var slots = $('[data-nvd-slots]', bx), count = $('[data-nvd-box-count]', bx), total = $('[data-nvd-box-total]', bx), cta = $('[data-nvd-box-add]', bx);
    function chipData(c) { return { id: parseInt(c.getAttribute('data-id'), 10), title: c.getAttribute('data-title'), price: parseInt(c.getAttribute('data-price'), 10), img: c.getAttribute('data-img') }; }
    function render() {
      var html = '';
      for (var i = 0; i < max; i++) {
        var p = picked[i];
        if (p) {
          html += '<button type="button" class="nvd-slot is-filled" data-slot="' + i + '" aria-label="Remove ' + esc(p.title) + ' from your box"' +
            (p.img ? ' style="background-image:url(\'' + esc(sizedImg(p.img, 300)) + '\')"' : '') + '><span class="nvd-slot__name">' + esc(p.title) + '</span></button>';
        } else {
          html += '<span class="nvd-slot" aria-hidden="true">+</span>';
        }
      }
      slots.innerHTML = html;
      count.textContent = picked.length + ' of ' + max;
      total.textContent = money(picked.reduce(function (s, p) { return s + p.price; }, 0));
      chips.forEach(function (c) {
        var id = parseInt(c.getAttribute('data-id'), 10);
        var on = picked.some(function (p) { return p.id === id; });
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
        c.disabled = c.hasAttribute('data-soldout') || (!on && picked.length >= max);
      });
      cta.disabled = picked.length === 0;
    }
    bx.addEventListener('click', function (e) {
      var c = e.target.closest('[data-nvd-chip]');
      if (c && !c.disabled) {
        var d = chipData(c);
        var idx = -1; picked.forEach(function (p, k) { if (p.id === d.id) idx = k; });
        if (idx > -1) picked.splice(idx, 1); else if (picked.length < max) picked.push(d);
        render(); return;
      }
      var s = e.target.closest('[data-slot]');
      if (s) { picked.splice(parseInt(s.getAttribute('data-slot'), 10), 1); render(); return; }
      if (e.target.closest('[data-nvd-box-add]') && picked.length) {
        var ref = 'Box ' + Math.random().toString(36).slice(2, 6).toUpperCase();
        var props = {}; props[prop] = ref;
        var items = picked.map(function (p) { return { id: p.id, quantity: 1, properties: props }; });
        addItems(items, 'Your Diwali box (' + items.length + ' items)', cta).then(function (ok) { if (ok) { picked = []; render(); openDrawer(); } });
      }
    });
    render();
  });

  fetchCart().catch(function () {});
})();
